import React, { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'; 

import { getSizedImageUrl } from '../../../../../scripts/utils/image'

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import GreyBoxYellowBoxSwitcheroo from '../components/GreyBoxYellowBoxSwitcheroo';

import SubBuilderStep from '../components/SubBuilderStep';
import Sticker from '../components/SubBuilderSticker';
import ToolTip from '../components/SubBuilderToolTip';



const Grind: React.FunctionComponent = () => {
  const { settings, actions, state } = useSubBuilder()
  const [openToolTipIndex, setOpenToolTipIndex] = useState(-1)
 
  return (
    <SubBuilderStep className="sub-builder-grind" index={3} stepConfig={settings.steps.grind}>
      <>
        {state.subscriptionType === 'me' ? settings.steps.grind.options.map(({ title, optionName, image, info, sticker }, i) => (
          <button className="sub-builder-btn-grind sub-builder-btn" id={`sub-builder-btn-grind-${i}`} key={optionName} type="button" onClick={() => {
            actions.setGrindOption(optionName, true)
            actions.moveStep(+1)
          }}>
            <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-grind-img">
              <img src={getSizedImageUrl(image, '300x300')} data-lazy-load />
            </GreyBoxYellowBoxSwitcheroo>
            <div className="flex align-center justify-center">
              <span className="sub-builder-btn-title text-upper">{title}</span>
              <ToolTip onClick={(e) => {
                e.stopPropagation();
                if (openToolTipIndex === i) {
                  setOpenToolTipIndex(-1)
                  return
                }
                setOpenToolTipIndex(i);
              }
              } open={openToolTipIndex === i}>{ReactHtmlParser(info)}</ToolTip>
            </div>
            
            {state.subscriptionType === 'gift' && sticker && <Sticker text={sticker} />}
          </button>
        )) : settings.steps.grind.options.map(({ title, optionName, image, info, sticker }, i) => (
          <button className="sub-builder-btn-grind sub-builder-btn" id={`sub-builder-btn-grind-${i}`} key={optionName} type="button" onClick={() => {
            actions.setGrindOption(optionName, false)
            actions.moveStep(+1)
          }}>
            <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-grind-img">
              <img src={getSizedImageUrl(image, '300x300')} data-lazy-load />
            </GreyBoxYellowBoxSwitcheroo>
            <div className="flex align-center justify-center">
              <span className="sub-builder-btn-title text-upper">{title}</span>
              <ToolTip onClick={(e) => {
                e.stopPropagation();
                if (openToolTipIndex === i) {
                  setOpenToolTipIndex(-1)
                  return
                }
                setOpenToolTipIndex(i);
              }
              } open={openToolTipIndex === i}>{ReactHtmlParser(info)}</ToolTip>
            </div>
            
            {state.subscriptionType === 'gift' && sticker && <Sticker text={sticker} />}
          </button>
        ))}
      </>
    </SubBuilderStep>)
   

}
export default Grind
